import { Table, Tag } from "antd";
import React from "react";
import { FormatNumber } from "../../../Utils/cartmgt";

const renderProduct = (img, title, isPromo) => {
  return (
    <div className="d-flex align-items-center gap-2">
      {img ? (
        <img
          src={img}
          alt={`${title}`}
          style={{
            width: "3vw",
            height: "3vh",
            objectFit: "cover",
            borderRadius: "4px",
          }}
        />
      ) : (
        <div
          style={{
            width: "3vw",
            height: "3vh",
            backgroundColor: "#f0f0f0",
            borderRadius: "4px",
          }}
        />
      )}
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>{title}</span>
        {isPromo && (
          <Tag
            color="gold"
            style={{
              fontSize: "10px",
              width: "fit-content",
              marginTop: "2px",
              lineHeight: "12px",
              padding: "0 4px",
            }}
          >
            Promo Deal
          </Tag>
        )}
      </div>
    </div>
  );
};

const ProductTable = (props) => {
  const { data } = props;

  // Helper: Check if Promo is Active (using the product data attached to the item)
  const isPromoActive = (product) => {
    if (product?.is_promo_product !== 1 && product?.is_promo_product !== true)
      return false;
    return true; // Assuming if it's in the order history as a promo, we honor it.
  };

  // Helper: Calculate exact subtotal for a line item
  const calculateItemSubtotal = (item) => {
    const product = item?.product;
    const qty = Number(item?.qty) || 0;

    const standardTotal =
      (Number(item?.amount) || Number(product?.amount) || 0) * qty;

    if (isPromoActive(product)) {
      const promoAmount = Number(product.promo_amount) || 0;
      // 👉 FIX: Multiply bundle count directly by promo amount
      return qty * promoAmount;
    }

    return standardTotal;
  };

  // Helper: Get the Unit Price (What to display in the "Price" column)
  const getUnitPriceDisplay = (item) => {
    const product = item?.product;
    if (isPromoActive(product)) {
      // Display the bundle price format for promos
      return ` ${FormatNumber(product.promo_amount)}`;
    }
    // Display standard unit price
    return FormatNumber(item?.amount || product?.amount);
  };

  const columns = [
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      render: (product) =>
        renderProduct(
          product?.images?.[0]?.url,
          product?.name,
          isPromoActive(product),
        ),
      sorter: (a, b) => a.product?.name?.localeCompare(b?.product?.name),
    },
    {
      title: "Price",
      key: "price",
      render: (_, record) => {
        const product = record.product;
        const isPromo = isPromoActive(product);
        return (
          <span
            className="orderHistory-text"
            style={{
              color: isPromo ? "#D4AF37" : "inherit",
              fontWeight: isPromo ? "bold" : "normal",
            }}
          >
            {getUnitPriceDisplay(record)}
          </span>
        );
      },
      sorter: (a, b) =>
        (Number(a.amount) || Number(a.product?.amount)) -
        (Number(b.amount) || Number(b.product?.amount)),
    },
    {
      title: "Quantity",
      dataIndex: "qty",
      key: "qty",
      render: (text, record) => {
        const product = record.product;
        const isPromo = isPromoActive(product);
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span className="orderHistory-text fw-bold">
              {isPromo ? product?.unit * text : text}
            </span>
            {isPromo && (
              <span style={{ fontSize: "10px", color: "#888" }}>
                ({text} Bundle)
              </span>
            )}
          </div>
        );
      },
      sorter: (a, b) => a.qty - b.qty,
    },
    {
      title: "Subtotal",
      key: "subtotal",
      render: (_, record) => {
        const subtotal = calculateItemSubtotal(record);
        const isPromo = isPromoActive(record.product);
        return (
          <span
            className="orderHistory-text"
            style={{
              fontWeight: "bold",
              color: isPromo ? "#252A4D" : "inherit",
            }}
          >
            {FormatNumber(subtotal)}
          </span>
        );
      },
      sorter: (a, b) => calculateItemSubtotal(a) - calculateItemSubtotal(b),
    },
  ];

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        className="custom-table"
        pagination={false}
        rowKey="id"
      />
    </>
  );
};

export default ProductTable;
